import * as React from 'react';
const SvgSmartphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path fill="currentColor" d="M11.167 14.333a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.75 5A2.75 2.75 0 0 1 7.5 2.25h5A2.75 2.75 0 0 1 15.25 5v10a2.75 2.75 0 0 1-2.75 2.75h-5A2.75 2.75 0 0 1 4.75 15zM7.5 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSmartphone;
